import { render, staticRenderFns } from "./TrGameControlPanel.vue?vue&type=template&id=809f12c4&scoped=true&"
import script from "./TrGameControlPanel.vue?vue&type=script&lang=js&"
export * from "./TrGameControlPanel.vue?vue&type=script&lang=js&"
import style0 from "./TrGameControlPanel.vue?vue&type=style&index=0&id=809f12c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "809f12c4",
  null
  
)

export default component.exports